// @flow
import { createAction } from 'redux-actions';
import { type ClientProperty } from './types';

export const fetchClientProperties = createAction(
  '@client/properties/fetch',
  (clientId: Id) => clientId
);

export const storeClientProperties = createAction(
  '@client/properties/store',
  (payload: Array<ClientProperty>) => payload,
  (_, clientId: Id) => clientId
);



// WEBPACK FOOTER //
// ./src/containers/client/clientPropertiesActions.js